
import { Component, OnInit, Input, ViewChildren, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-module',
  templateUrl: './module.component.html',
  styleUrls: ['./module.component.css']
})
export class ModuleComponent implements OnInit {

  @Input() module: any;
  @Input() inPackage: boolean = false;
  @Input() currentUserIsAdmin: boolean = false;
  @Output() deleteClicked = new EventEmitter<any>();
  // @ViewChild('moduleTile') moduleTile: ElementRef;
  // @ViewChild('moduleTileImg') moduleTileImg: ElementRef;
  @ViewChild('infoToggle') infoToggle :ElementRef;
  
  url='../moduledetails';
  routerParams;
  environment;
  // The user's token used to be read here for a live-meeting link that embedded it as a
  // query parameter. That link is gone; the token read went with it.
  constructor(private router: Router, private moduleservice: ModulemanagementService) {
    this.environment = environment;
  }

  async ngOnInit() {
    this.routerParams = { moduleID: this.module.id };
  }


  deleteClickedFired(module){
    this.deleteClicked.emit(module);
  }
 
}
